
    import * as React from 'react';

    const SoundOn36 = ({ color = 'currentcolor', height = '36px', width = '36px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 36 36" fill="none" style={svgStyle}><circle cx={18} cy={18} r={18} fillOpacity={0.7} /><path d="M7.875 13.7392V21.5109H11.3424L18.337 27.2501V8L11.3424 13.7392H7.875Z" fill="white" /><path d="M23.3344 9L22.5223 9.87227C24.718 11.9477 25.9211 14.6848 25.9211 17.5723C25.9211 20.4598 24.718 23.1969 22.4922 25.2422L23.3043 26.1145C25.7707 23.8586 27.1242 20.8207 27.1242 17.5723C27.1242 14.3238 25.7707 11.2859 23.3344 9Z" fill="white" /><path d="M21.8305 11.707L21.0184 12.5793C22.432 13.9328 23.2141 15.7074 23.2141 17.5723C23.2141 19.4371 22.432 21.2117 20.9883 22.5352L21.8004 23.4074C23.4848 21.8735 24.4172 19.7981 24.4172 17.5723C24.4172 15.3465 23.4848 13.2711 21.8305 11.707Z" fill="white" /><path d="M20.3273 14.4443L19.4551 15.2865C20.6582 16.5498 20.6582 18.5951 19.4551 19.8584L20.3273 20.7006C21.9816 18.9861 21.9816 16.1588 20.3273 14.4443Z" fill="white" /></svg>
        </div>
      );
    };

    SoundOn36.displayName = 'SoundOn36';

    export default SoundOn36;
  